<template>
  <div class="grid" />
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
@use "@qmulus/ui/styles/variables/theme";

.grid {
  background-color:  theme.$shade000 ;
  background-image:
    repeating-linear-gradient(0deg, theme.$shade200 0, theme.$shade200 1px, transparent 1px, transparent 40px),
    repeating-linear-gradient(90deg, theme.$shade200 0, theme.$shade200 1px, transparent 1px, transparent 40px);
}
</style>
